function updateFabricLabels() {
  const configs = {
    "Cotton Blend": "30% Cotton / 70% Polyester",
    "UV Protection": "UPF 50+"
  };

  Object.entries(configs).forEach(([title, subtitleText]) => {
    document
      .querySelectorAll(`label.tee-radio-label--color[title="${title}"]`)
      .forEach(label => {
        if (label.querySelector(".fabric-composition")) return;

        label.style.flexDirection = "column";

        const existingSpan = label.querySelector("span");
        if (existingSpan) {
          existingSpan.style.display = "block";
        }

        const subtitle = document.createElement("span");
        subtitle.className = "fabric-composition";
        subtitle.textContent = subtitleText;
        subtitle.style.cssText = `
          display:block;
          font-size:10px;
          font-weight:normal;
          margin-top:2px;
        `;

        label.appendChild(subtitle);
      });
  });
}

document.addEventListener("teeinblue-event-component-injected", () => {

  const headings = document.querySelectorAll(".tee-field__heading");

  headings.forEach(el => {
    if (el.innerText.toLowerCase().includes("preview method")) {
      if (!el.parentElement.querySelector(".tee-field__help")) {
        const helpText = document.createElement("div");
        helpText.className = "tee-field__help";
        helpText.innerText =
          "Instant preview may not work with some images. You can upload for manual design instead.";

        el.insertAdjacentElement("afterend", helpText);
      }
    }
  });

  const field = document.querySelector(".tee-field--template");

  if (field) {
    const helpText = field.querySelector(".tee-field__help");
    const heading = field.querySelector(".tee-field__heading");
    const selectWrapper = field.querySelector(".tee-select-wrapper");
    const select = field.querySelector(".tee-field__select");
    const previewBtn = document.querySelector(".tee-btn--preview");

    const TEXT_UPLOAD = "Need human support for your design? Click here!";
    const TEXT_PREVIEW = "Back to live preview";

    if (helpText && heading && selectWrapper && select) {

      helpText.style.cursor = "pointer";
      helpText.style.fontSize = "16px";
      helpText.textContent = TEXT_UPLOAD;

      helpText.addEventListener("click", function () {
        const isUploadMode = helpText.textContent === TEXT_UPLOAD;

        heading.style.display = "";
        selectWrapper.style.display = "";

        if (isUploadMode) {
          select.value = select.querySelector("option:last-child").value;
          helpText.textContent = TEXT_PREVIEW;

          if (previewBtn) previewBtn.style.display = "none";
        } else {
          select.value = select.querySelector("option:nth-child(2)").value;
          helpText.textContent = TEXT_UPLOAD;

          if (previewBtn) previewBtn.style.display = "";
        }

        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }

  // Add fabric labels
  updateFabricLabels();

  const handle = window.location.pathname.toLowerCase();


  const isPolo = handle.includes("polo");


  if (!isPolo) return;

  const fields = document.querySelectorAll(".tee-field");


  fields.forEach(field => {
    const heading = field.querySelector(".tee-field__heading");
    if (!heading) return;

    const text = heading.innerText.trim();

    if (text.includes("Pocket")) {
      field.style.display = "none";
    }
  });
});

// Observe TeeInBlue re-render
const observer = new MutationObserver(() => {
  updateFabricLabels();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener("click", e => {
  console.log("listen clicke");

  const contactBtn = e.target.closest(".contact-us-teeinblue");


  if (!contactBtn) return;


  document
    .querySelector(
      'button[popovertarget="CallNowPopover-mobile-hidden"]'
    )
    ?.click();
});